module.exports = __webpack_public_path__ + "static/img/19.12b784b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/eng/19.png
// module id = 4LbB
// module chunks = 0